import { Component, DestroyRef, Input, ViewChild, OnInit, OnDestroy, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { skip } from 'rxjs';
import { MessageService } from 'primeng/api';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { NursingAuditService } from "src/app/services/nursing-audit.service";
import { AuthService } from 'src/app/services/auth.service';
import { Audit2Component } from '../../nursing-audit/audit2/audit2.component';
import { environment } from 'src/environments/environment';
import { RiskScoreChartComponent } from 'src/app/nursing-audit/risk-score-chart/risk-score-chart.component';
import { DOCUMENT } from '@angular/common';
import { NotesModalComponent } from 'src/app/nursing-audit/notes-modal/notes-modal.component';
import { UrcComponent } from 'src/app/variance/urc/urc.component';
import { ShareModalComponent } from 'src/app/nursing-audit/share-modal/share-modal.component';
import { SelectItem } from 'primeng/api';
import { InvestigativeSummaryComponent } from 'src/app/nursing-audit/investigative-summary/investigative-summary.component';
import { PrintModalComponent } from 'src/app/nursing-audit/print-modal/print-modal.component';
import { ResolutionCodingService } from 'src/app/services/resolution-coding.service';
import { DocumentService } from "src/app/services/document.service";
import { FollowUpModalComponent } from 'src/app/nursing-audit/follow-up-modal/follow-up-modal.component';
import { LocationSelectComponent } from 'src/app/shared/location-select/location-select.component';
import { LocationAccessService } from 'src/app/services/location-access.service';
import { Table } from 'primeng/table';
import { cloneFilterState, DataFilterService, FilterState } from 'src/app/services/data-filter.service';
import { ThemeColorService } from 'src/app/services/theme-color.service';
import { ThemePreferenceService } from 'src/app/services/theme-preference.service';

@Component({
    selector: 'app-executive-dashboard',
    templateUrl: './executive-dashboard.component.html',
    styleUrls: ['./executive-dashboard.component.scss'],
    standalone: false
})
export class ExecutiveDashboardComponent implements OnInit, OnDestroy {
  authService = inject(AuthService);
  private auditService = inject(NursingAuditService);
  private messageService = inject(MessageService);
  private resolutionCodingService = inject(ResolutionCodingService);
  private documentService = inject(DocumentService);
  private document = inject<Document>(DOCUMENT);
  private locationAccessService = inject(LocationAccessService);
  private dataFilterService = inject(DataFilterService);
  private themeColorService = inject(ThemeColorService);
  private themePreferenceService = inject(ThemePreferenceService);
  private destroyRef = inject(DestroyRef);
  private latestChartResponse: any;

  filter:any = {};
  private filterState?: FilterState<any>;
  @ViewChild('adminRiskTable') adminRiskTable?: Table;
  auditTableCount:any = 0
  auditorSelection:any = {}
  private locationChangeTimeout: any;
  private isProcessingLocationChange = false;
  loc_filter_breakdown= ''
  footprint:string = environment.footprint
  highRiskDiscrepancies:any = {};
  totalHighRiskResolutions:any = 0;
  totalResolutions:any = 0;
  highRiskOptions:any;
  interactionTotal:any = {};
  interactionOptions:any;
  discrepanciesTotal:any = {};
  discrepanciesOptions :any;
  adminCount:any = {};
  adminCountOptions: any;
  chartLegendLabels: string[] = [];
  chartLegendColors: string[] = [];
  combinationRate = '0%';
  page = 0;
  filterDialog = false;
  dateSelector!: boolean;
  loading = true;
  @ViewChild('audit2') audit2!:Audit2Component;
  @ViewChild('riskScoreChart') riskScoreChart!: RiskScoreChartComponent;
  @ViewChild("notesComponent") notesComponent!: NotesModalComponent;
  @ViewChild('varianceComponent') resolutionComp!: UrcComponent;
  @ViewChild('shareModal') shareComponent!: ShareModalComponent;
  @ViewChild('investigativeSummary') InvestigativeSummaryData!: InvestigativeSummaryComponent;
  @ViewChild('printModal') printComponent!: PrintModalComponent;
  @ViewChild("fdialog") followUp!: FollowUpModalComponent;
  @ViewChild("locationSelectComp") locationSelectComp!: LocationSelectComponent;
  commentDialog = false
  followUpDialog = false
  showISPrintModal = false
  @Input() defaultRows = 5;
  @Input() deId=false;
  overViews:any = {
    totalHighRisk: 0,
    totalInteraction:0,
    totalDiscrepincyRate:0,
  };
  regionDescrep:any = {
    totalDiscrepancyRate:0
  };
  adminHighRiskData:any[] = [];
  showInvestigativeSummary = false
  selectedAdminData:any={}
  adminCountCol:any[] = [];
  adminCountReport:any;
  discrepancies:any;
  currentPage: any = null;
  plugin = ChartDataLabels;
  showRiskScoreChart = false;
  maapRiskInfo!:boolean;
  selectedDays: any = 90;
  currentRow: any = {};
  riskLevel: any;
  individualDiscrepancyDialog = false;
  selectedRow: any = {};
  iaFilter: any = {};
  showShareModal = false;
  date: any = {}
  showTransactionByMultiAdmins = false;
  individualActivityDialog = false;
  showMultiAdmins = false;
  days: SelectItem[] = [
    {label: '90 Days', value: 90},
    {label: '30 Days', value: 30},
    {label: '7 Days', value: 7}
  ];
  filterOptions: any = {};
  locationSelectFilter: any = {region:[], campus:[] , facility:[] , changeValue: true};

  private loggedRows = new Set();

  constructor() {
    this.themePreferenceService.preference$
      .pipe(skip(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.refreshChartTheme());
  }

  private refreshChartTheme(): void {
    if (!this.latestChartResponse) {
      return;
    }

    this.loadHighRiskDiscrepanciesChart(this.latestChartResponse);
    this.loadInteractionTotal(this.latestChartResponse);
    this.loadDiscrepanciesTotal(this.latestChartResponse);
    this.loadAdminCount(this.latestChartResponse);
  }

  ngOnInit(){
    // this.chartJs.plugins.unregister(this.chartLabelPlugin);
    if (this.footprint == 'small')
      this.loc_filter_breakdown = 'Sites'
    else
      this.loc_filter_breakdown = 'Region'
    this.setInitialFilter()
    this.loadAdminHighRisk({});
    // this.loadOverViews();
    // this.refreshData();

    this.locationSelectFilter = this.locationAccessService.buildInitialFilters(this.authService.user, {
      footprint: this.footprint,
      changeValue: true
    });
  }
   refreshData(){
    this.filter.footprint = this.footprint
    this.auditService.getExecutiveDash(this.filter).subscribe((res)=> {
      this.latestChartResponse = res;
      this.loadAuditorFollowUp(res); 
      this.loadRegionDescrepancyRate(res);
      this.loadHighRiskDiscrepanciesChart(res);
      this.loadInteractionTotal(res);
      this.loadDiscrepanciesTotal(res);
      this.loadAdminCount(res);
          
    })
   }

  loadOverViews(){
    this.overViews.totalHighRisk = 0
    

   }
   
   loadAdminHighRisk(event: any){
    if(event["first"] || event['first'] == 0){
      this.page = event['first']

    }

    this.auditService.getAuditPagedDataParent(this.page, 100, this.filter).subscribe((res)=> {
      // this.audit2.totalCount = res['count']
      this.auditTableCount = (res as any)['count']
      this.adminHighRiskData = (res as any)["docs"]
    })
    
    }
    getRiskFlag(row: any){
    if(!row || row.locationGrouping == "MULTIPLE" || row.subParent)
    return "black-white"

    if(row.risk_score_flag == "green" || row.riskScoreFlag == "green")
    return "green-circle";
    else if(row.risk_score_flag == "red_white" || row.riskScoreFlag == "red_white")
    return "red-square";
    else if(row.risk_score_flag == "red" || row.riskScoreFlag == "red")
    return "red-square";
    else if(row.risk_score_flag == "yellow" || row.riskScoreFlag == "yellow")
    return "yellow-triangle";
    else
    return "green-circle"
    }
    
    getScoreMovement(row: any){
    if (row.scoreMovement == "down")
      return "/assets/images/icon_decline_green.svg";
    else if (row.scoreMovement == "nc")
      return "/assets/images/icon_cline_yellow.svg";
    else  
      return "/assets/images/icon_incline_red.svg";
    }


  loadRegionDescrepancyRate(res: any){
      this.regionDescrep = res
      const deleteIndexes = []
      let mainTotal = 0 
      let mainHighRisk = 0
      
      // Filter out N/A, none, null, undefined, and empty location groupings, plus undefined rows
      if (res.regionData) {
        res.regionData = res.regionData.filter((item: any) => {
          if (!item) return false; // Filter out undefined/null items
          const locationGrouping = item.locationGrouping || (item._id && item._id.locationGrouping);
          const normalizedValue = locationGrouping?.toString().toLowerCase().trim();
          return locationGrouping && 
                 normalizedValue !== 'n/a' && 
                 normalizedValue !== 'none' && 
                 normalizedValue !== 'null' && 
                 normalizedValue !== 'undefined' &&
                 normalizedValue !== '';
        });
      }
      
      for (let i = 0; i < res.regionData.length; i ++){
        mainTotal = mainTotal + res.regionData[i]['totalCount']
        mainHighRisk = mainHighRisk + res.regionData[i]['highRiskCount']
        if (res.regionData[i]['discrepancyRate'] == 0){
          deleteIndexes.push(i)
        }
      }
      deleteIndexes.slice().reverse().forEach(idx => delete res.regionData[idx])
      this.regionDescrep.totalDiscrepincyRate = ((mainHighRisk/mainTotal)*100).toPrecision(2)
  }

  getRegionBg(row: any){
    let bgColor = {};
    
    if (!row || !this.regionDescrep || !this.regionDescrep["colorScheme"]) {
      return bgColor;
    }
    
    this.regionDescrep["colorScheme"].forEach((color: any) => {
      let key;
      
      if(this.footprint == 'small'){
        if (row['adcDevice'] && this.loc_filter_breakdown == 'adcDevice'){
          key = row['adcDevice'].charAt(0).toUpperCase() + row.adcDevice.slice(1)
        }
        else if (row['locationGrouping'] && this.loc_filter_breakdown == 'LocationGrouping'){
          key = row['locationGrouping'].charAt(0).toUpperCase() + row.locationGrouping.slice(1)
        }else if (row['facility']){
          key = row['facility'].charAt(0).toUpperCase() + row.facility.slice(1)
        }
      }else{
        if (row['adcDevice'] && this.loc_filter_breakdown == 'adcDevice'){
          key = row['adcDevice'].charAt(0).toUpperCase() + row.adcDevice.slice(1)
        }
        else if (row['_id'] && row['_id']['locationGrouping'] && this.loc_filter_breakdown == 'LocationGrouping'){
          key = row['locationGrouping'].charAt(0).toUpperCase() + row.locationGrouping.slice(1)
        }else if (row['_id'] && row['_id']['facility'] && this.loc_filter_breakdown == 'Facility'){
          key = row['facility'].charAt(0).toUpperCase() + row.facility.slice(1)
        }else if (row['_id'] && row['_id']['campus'] && this.loc_filter_breakdown == 'Campus'){
          key = row['campus'].charAt(0).toUpperCase() + row.campus.slice(1)
        }else if (row['region']){
          key = row['region'].charAt(0).toUpperCase() + row.region.slice(1)
        }   
      }
      
      if (!key) {
        return;
      }    
      if(key == color["grouping"]){
        let colorName = color['color']
        if(colorName[0].indexOf(' ') > 0)
          colorName = colorName[0].split(' ')
        if(colorName.includes('yellow') || colorName.includes('light') || colorName.includes('aqua') || colorName.includes('chartreuse') || colorName.includes('jasmine')){
          bgColor = {
            'background-color': color["colorCode"],
            'font-weight': 'bolder',
            'color': 'rgb(var(--text-on-chart-light-surface))'
          }
        }
        else{
          bgColor = {
            'background-color': color["colorCode"],
            'font-weight': 'bolder',
            'color': 'rgb(var(--text-on-chart-dark-surface))'
          }
        }
      } 
      row.label = key    
    })
    return bgColor
  }

  getDescrpeLabel(row: any) {
    if (!row || !row['_id']) {
      return '';
    }
    
    if (row['_id']['adcDevice']) {
        return row['_id']['adcDevice'];
    }
    else if (row['_id']['locationGrouping']) {
        return row['_id']['locationGrouping'];
    } else if (row['_id']['facility']) {
        return row['_id']['facility'];
    } else if (row['_id']['campus']) {
        return row['_id']['campus'];
    } else if (row['_id']['region']) {
      return row['_id']['region'];
    } 
    
    return '';
  }

  getDiscrepincyRate(row: any){
    if (!row || row.discrepancyRate === undefined || row.discrepancyRate === null) {
      return '0.00%';
    }
    
    const percentRate = row
    const riskPercent = parseFloat(percentRate["discrepancyRate"]).toFixed(2);
    const result = riskPercent.toString() + '%'
    return result
  }

  loadHighRiskDiscrepanciesChart(res: any){
      const labels: any[] = []
      const values: any[] = []
      const colors: any[] = []
      const chartTextColor = this.themeColorService.resolve('--text-primary')
      let chartDataSet = []
      let data = res["regionData"]
      const colorScheme = res["colorScheme"]
      
      // Filter out N/A, none, null, undefined, and empty location groupings
      data = data.filter((rec: any) => {
        const locationGrouping = rec.locationGrouping || (rec._id && rec._id.locationGrouping);
        const normalizedValue = locationGrouping?.toString().toLowerCase().trim();
        return locationGrouping && 
               normalizedValue !== 'n/a' && 
               normalizedValue !== 'none' && 
               normalizedValue !== 'null' && 
               normalizedValue !== 'undefined' &&
               normalizedValue !== '';
      });
      
      data.map((rec: any)=> {
        if(rec['_id']['adcDevice']){
          labels.push(this.isDeId(rec.adcDevice))
        }
        else if(rec['_id']['locationGrouping']){
          labels.push(this.isDeId(rec.locationGrouping))
        }
        else if(rec['_id']['facility']){
          labels.push(this.isDeId(rec.facility))
        }
        else if(rec['_id']['campus']){
          labels.push(this.isDeId(rec.campus))
        }
        else{
          labels.push(this.isDeId(rec.region))
        } 
        values.push(rec.highRiskCount)
        colorScheme.forEach((color: any)=>{
          if(this.footprint == 'small'){
            if(color["grouping"] == rec.adcDevice){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.locationGrouping){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.facility){
              colors.push(color["colorCode"])
            }
          }else{
            if(color["grouping"] == rec.adcDevice){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.locationGrouping){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.facility.charAt(0).toUpperCase() + rec.facility.slice(1)){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.campus.charAt(0).toUpperCase() + rec.campus.slice(1)){
                colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.region.charAt(0).toUpperCase() + rec.region.slice(1)){
              colors.push(color["colorCode"])
            }
          }      
        })
      })
      chartDataSet = [{data:values}]
      this.totalHighRiskResolutions = values.reduce((a, b) => a + b, 0);
      this.totalHighRiskResolutions = this.totalHighRiskResolutions.toLocaleString('en-US')
      if(colorScheme.length > 0){
        (chartDataSet as any)[0]["backgroundColor"] = colors;
      }
      
      // Populate legend data
      this.chartLegendLabels = labels;
      this.chartLegendColors = colors;
      
      // Calculate combination rate
      const totalValues = values.reduce((a, b) => a + b, 0);
      if(totalValues > 0) {
        this.combinationRate = ((values[0] / totalValues) * 100).toFixed(1) + '%';
      }
      
      this.highRiskDiscrepancies = {
        labels: labels,
        datasets:chartDataSet
      }
      this.highRiskOptions = {
        plugins:{
          legend: {
            display: false,
            labels: {
              color: chartTextColor
            }
          },
          title:{display:true, text:'High Risk Variances',color:chartTextColor,size:45},
          plugins:{
            datalabels:{   
                formatter: (value: any, ctx: any) => {
                let sum = 0;
                const dataArr = ctx.chart.data.datasets[0].data;
                dataArr.map((data: any) => {
                      sum += data;
                });
                const percentage = (value * 100 / sum); 
                return percentage !== 0 ? percentage.toFixed(2) + '%' : '';
              },
              color: chartTextColor,
            }
          }
        } 
      }
  };
  
  loadInteractionTotal(res: any){
      const labels: any[] = []
      const values: any[] = []
      const colors: any[] = []
      const chartTextColor = this.themeColorService.resolve('--text-primary')
      let chartDataSet = []
      let data = res["regionData"]
      const colorScheme = res["colorScheme"]
      
      // Filter out N/A, none, null, undefined, and empty location groupings
      data = data.filter((rec: any) => {
        const locationGrouping = rec.locationGrouping || (rec._id && rec._id.locationGrouping);
        const normalizedValue = locationGrouping?.toString().toLowerCase().trim();
        return locationGrouping && 
               normalizedValue !== 'n/a' && 
               normalizedValue !== 'none' && 
               normalizedValue !== 'null' && 
               normalizedValue !== 'undefined' &&
               normalizedValue !== '';
      });
      
      data.map((rec: any) => {
        if(rec['_id']['adcDevice']){
          labels.push(this.isDeId(rec.adcDevice))
        }
        else if(rec['_id']['locationGrouping']){
          labels.push(this.isDeId(rec.locationGrouping))
        }
        else if(rec['_id']['facility']){
          labels.push(this.isDeId(rec.facility))
        }
        else if(rec['_id']['campus']){
          labels.push(this.isDeId(rec.campus))
        }
        else{
          labels.push(this.isDeId(rec.region))
        }
        values.push(rec.totalCount)
        colorScheme.forEach((color: any)=>{
          if(this.footprint == 'small'){
            if(color["grouping"] == rec.adcDevice){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.locationGrouping){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.facility){
              colors.push(color["colorCode"])
            }
          }else{
            if(color["grouping"] == rec.adcDevice){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.locationGrouping){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.facility.charAt(0).toUpperCase() + rec.facility.slice(1)){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.campus.charAt(0).toUpperCase() + rec.campus.slice(1)){
                colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.region.charAt(0).toUpperCase() + rec.region.slice(1)){
              colors.push(color["colorCode"])
            }
          }      
        })
      })
      chartDataSet = [{data:values}]
      this.totalResolutions = values.reduce((a, b) => a + b, 0);
      this.totalResolutions = this.totalResolutions.toLocaleString('en-US')
      if(colorScheme.length > 0){
        (chartDataSet as any)[0]["backgroundColor"] = colors;
      }
      this.interactionTotal = {
        labels: labels,
        datasets:chartDataSet,
      }
      this.interactionOptions = {
        plugins:{
          legend: {
            display: false,
            labels: {
              color: chartTextColor
            }
          },
          title:{display:true, text:'Total Variances',color:chartTextColor,size:45},
          datalabels:{display:true}
        } 
      }
  }

  loadDiscrepanciesTotal(res: any){
      const labels: any[] = []
      const values: any[] = []
      const colors: any[] = []
      const chartTextColor = this.themeColorService.resolve('--text-primary')
      let chartDataSet = []
      let data = res["regionData"]
      const colorScheme = res["colorScheme"]
      
      // Filter out N/A, none, null, undefined, and empty location groupings
      data = data.filter((rec: any) => {
        const locationGrouping = rec.locationGrouping || (rec._id && rec._id.locationGrouping);
        const normalizedValue = locationGrouping?.toString().toLowerCase().trim();
        return locationGrouping && 
               normalizedValue !== 'n/a' && 
               normalizedValue !== 'none' && 
               normalizedValue !== 'null' && 
               normalizedValue !== 'undefined' &&
               normalizedValue !== '';
      });
      
      data.map((rec: any) => {
        if(rec['_id']['adcDevice']){
          labels.push(this.isDeId(rec.adcDevice))
        }
        else if(rec['_id']['locationGrouping']){
          labels.push(this.isDeId(rec.locationGrouping))
        }
        else if(rec['_id']['facility']){
          labels.push(this.isDeId(rec.facility))
        }
        else if(rec['_id']['campus']){
          labels.push(this.isDeId(rec.campus))
        }
        else{
          labels.push(this.isDeId(rec.region))
        }
        values.push(rec.riskCount)      
        colorScheme.forEach((color: any)=>{
          if(this.footprint == 'small'){
            if(color["grouping"] == rec.adcDevice){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.locationGrouping){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.facility){
              colors.push(color["colorCode"])
            }
          }else{
            if(color["grouping"] == rec.adcDevice){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.locationGrouping){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.facility.charAt(0).toUpperCase() + rec.facility.slice(1)){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.campus.charAt(0).toUpperCase() + rec.campus.slice(1)){
                colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.region.charAt(0).toUpperCase() + rec.region.slice(1)){
              colors.push(color["colorCode"])
            }
          }
        })
      })
      chartDataSet = [{data:values}]
      if(colorScheme.length > 0){
        (chartDataSet as any)[0]["backgroundColor"] = colors;
      }
      this.discrepanciesTotal = {
        labels: labels,
        datasets: chartDataSet,
      }
      this.discrepanciesOptions = {
        plugins:{
          legend: {
            display: false,
            labels: {
              color: chartTextColor
            }
          },
          title:{display:true, text:'Variances with Risk > 0',color:chartTextColor,size:45},
          datalabels:{display:true}
        } 
      }
  }

  loadAdminCount(res: any){
      const labels: any[] = []
      const values: any[] = []
      const colors: any[] = []
      const chartTextColor = this.themeColorService.resolve('--text-primary')
      let chartDataSet = []
      let data = res["regionData"]
      const colorScheme = res["colorScheme"]
      
      // Filter out N/A, none, null, undefined, and empty location groupings
      data = data.filter((rec: any) => {
        const locationGrouping = rec.locationGrouping || (rec._id && rec._id.locationGrouping);
        const normalizedValue = locationGrouping?.toString().toLowerCase().trim();
        return locationGrouping && 
               normalizedValue !== 'n/a' && 
               normalizedValue !== 'none' && 
               normalizedValue !== 'null' && 
               normalizedValue !== 'undefined' &&
               normalizedValue !== '';
      });
      
      data.map((rec: any) => {
        if(rec['_id']['adcDevice']){
          labels.push(this.isDeId(rec.adcDevice))
        }
        else if(rec['_id']['locationGrouping']){
          labels.push(this.isDeId(rec.locationGrouping))
        }
        else if(rec['_id']['facility']){
          labels.push(this.isDeId(rec['_id']['facility']))
        }
        else if(rec['_id']['campus']){
          labels.push(this.isDeId(rec['_id']['campus']))
        }
        else{
          labels.push(this.isDeId(rec['_id']['region']))
        }
        values.push(rec.adminCount)
        colorScheme.forEach((color: any)=>{
          if(this.footprint == 'small'){
            if(color["grouping"] == rec.adcDevice){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.locationGrouping){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.facility){
              colors.push(color["colorCode"])
            }
          }else{
            if(color["grouping"] == rec.adcDevice){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.locationGrouping){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.facility.charAt(0).toUpperCase() + rec.facility.slice(1)){
              colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.campus.charAt(0).toUpperCase() + rec.campus.slice(1)){
                colors.push(color["colorCode"])
            }
            else if(color["grouping"] == rec.region.charAt(0).toUpperCase() + rec.region.slice(1)){
              colors.push(color["colorCode"])
            }
          }
        })
      })
      chartDataSet = [{data:values}]
      if(colorScheme.length > 0){
        (chartDataSet as any)[0]["backgroundColor"] = colors;
      }
      this.adminCount = {
        labels: labels,
        datasets: chartDataSet,
      }
      this.adminCountOptions = {
        plugins:{
          legend: {
            display: false,
            labels: {
              color: chartTextColor
            }
          },
          title:{display:true, text:'User Count',color:chartTextColor,size:45},
          datalabels:{display:true}
        } 
      }
    this.loading=false
  }

   loadAuditorFollowUp(res: any){
    if(res['adminFollowUpCount'])
      this.adminCountReport = res['adminFollowUpCount']
    // if(this.auditorSelection.user){
    for (const report of this.adminCountReport) {
      if(report['investigator'] == this.auditorSelection.user){
        report['selectedColumn'] = this.auditorSelection.column
      }
      else
      report['selectedColumn'] = ''
    }
    // }

    // Pin "System Generated" rows to the top
    this.adminCountReport.sort((a: any, b: any) => {
      const aIsSystem = a.investigator === 'System Generated' ? 0 : 1;
      const bIsSystem = b.investigator === 'System Generated' ? 0 : 1;
      return aIsSystem - bIsSystem;
    });

    this.adminCountCol = 
    [
      { field: "Open", header: "Open" },
      { field: "DDPTReviewInitiated", header: "DDPT Review - Initiated" },
      { field: "DDPTReviewLowRisk", header: "DDPT Review - Low Risk" },
      { field: "DDPTReviewMedRisk", header: "DDPT Review - Med Risk" },
      { field: "DDPTReviewHighRisk", header: "DDPT Review - High Risk" },
      { field: "ContinueSurveillance", header: "Continue Surveillance" },
      { field: "AdminResponsePending", header: "Admin Response Pending" },  
      { field: "UnitMgnDDPTReviewLow", header: "Unit Mgn/DDPT Review - Low" },    
      { field: "UnitMgnDDPTReviewMed", header: "Unit Mgn/DDPT Review - Med" },
      { field: "UnitMgnDDPTReviewHigh", header: "Unit Mgn/DDPT Review - High" },      
      { field: "DDPTInvestigation", header: "DDPT Investigation" },    
      { field: "DDPTProvidedEducation", header: "DDPT Provided Education" },
      { field: "DDPTTerminated", header: "DDPT Terminated" },
      { field: "DDPTReviewClosed", header: "DDPT Review - Closed" },
    ]
  }

  totalCount(row: any, col: any){
    if(row[col.field]){
      return row[col.field].length
    }else{
      return 0
    }
  }

  getFollowUpBG(val: string, selected: boolean): string {
    if(!selected){
    switch(val){
      case "Admin Response Pending": return "rgb(var(--status-follow-up-pending-fill))";
      case "Continue Surveillance": return "rgb(var(--status-follow-up-surveillance-fill))";
      case "DDPT Investigation": return "rgb(var(--status-follow-up-critical-fill))";
      case "DDPT Provided Education": return "rgb(var(--status-follow-up-positive-fill))";
      case "DDPT Review - Initiated": return "rgb(var(--status-follow-up-initiated-fill))";
      case "DDPT Review - Low Risk": return "rgb(var(--status-follow-up-positive-fill))";
      case "DDPT Review - Med Risk": return "rgb(var(--status-follow-up-surveillance-fill))";
      case "DDPT Review - High Risk": return "rgb(var(--status-follow-up-high-fill))";
      case "DDPT Terminated": return "rgb(var(--status-follow-up-critical-fill))";
      case "Open": return "rgb(var(--status-follow-up-open-fill))";
      case "Unit Mgn/DDPT Review - High": return "rgb(var(--status-follow-up-high-fill))";
      case "Unit Mgn/DDPT Review - Low": return "rgb(var(--status-follow-up-positive-fill))";
      case "Unit Mgn/DDPT Review - Med": return "rgb(var(--status-follow-up-surveillance-fill))";
      case "Unit Provided Education": return "rgb(var(--status-follow-up-positive-fill))";
      default: return "rgb(var(--status-follow-up-default-fill))"
    }
  }
  else{
    switch(val){
      case "Admin Response Pending": return "rgb(var(--status-follow-up-pending-selected-fill))";
      case "Continue Surveillance": return "rgb(var(--status-follow-up-surveillance-selected-fill))";
      case "DDPT Investigation": return "rgb(var(--status-follow-up-critical-selected-fill))";
      case "DDPT Provided Education": return "rgb(var(--status-follow-up-positive-selected-fill))";
      case "DDPT Review - Initiated": return "rgb(var(--status-follow-up-initiated-selected-fill))";
      case "DDPT Review - Low Risk": return "rgb(var(--status-follow-up-positive-selected-fill))";
      case "DDPT Review - Med Risk": return "rgb(var(--status-follow-up-surveillance-selected-fill))";
      case "DDPT Review - High Risk": return "rgb(var(--status-follow-up-high-selected-fill))";
      case "DDPT Terminated": return "rgb(var(--status-follow-up-critical-selected-fill))";
      case "Open": return "rgb(var(--status-follow-up-initiated-selected-fill))";
      case "Unit Mgn/DDPT Review - High": return "rgb(var(--status-follow-up-high-selected-fill))";
      case "Unit Mgn/DDPT Review - Low": return "rgb(var(--status-follow-up-positive-selected-fill))";
      case "Unit Mgn/DDPT Review - Med": return "rgb(var(--status-follow-up-surveillance-selected-fill))";
      case "Unit Provided Education": return "rgb(var(--status-follow-up-positive-selected-fill))";

      default: return "rgb(var(--status-follow-up-default-selected-fill))"
    }
  }
  }

  //START TO FILTERS STUFF 

  isDeId(name: any){
    if(this.deId)
      return "xxxxxx xxxxxx"
    else
      return name
  }
  
  showDateFilter(){
    this.dateSelector = true
  }

  updateEndDate(){
    this.filter.endDate = this.filter.startDate
  }
  submitDateSelector(){
    const obj = {};
    if(this.currentPage != null)
    (obj as any)["first"] = this.currentPage;
    else
    (obj as any)["first"] = 0;
    this.filter._id = [];
  }

onLocationChanged(event: any){
    
    // Prevent duplicate processing
    if (this.isProcessingLocationChange) {
        return;
    }
    
    // Clear any existing timeout
    if (this.locationChangeTimeout) {
        clearTimeout(this.locationChangeTimeout);
    }
    
    // Set flag to prevent duplicates
    this.isProcessingLocationChange = true;
    
    // Debounce the location change processingƒ
    this.locationChangeTimeout = setTimeout(() => {
        this.processLocationChange(event);
        this.isProcessingLocationChange = false; // Reset flag
    }, 150); // 150ms debounce
}

private processLocationChange(event: any) {
    this.filterDialog = false;
    this.loading = true;
    const sanitized = this.locationAccessService.sanitizeSelectedFilters(event, this.authService.user);
    this.locationSelectFilter = {
      ...sanitized,
      footprint: this.footprint,
      changeValue: event?.changeValue
    };
    this.locationAccessService.applyAuthorizedFilters(this.filter, sanitized, this.authService.user, 'locationGroup');

    if(this.locationAccessService.hasAll(sanitized.region)) {
        this.filter.adminId = []
        this.auditorSelection = {}
    }
    this.loc_filter_breakdown = this.locationAccessService.getFilterBreakdown(sanitized, {
        allLarge: 'Region',
        allSmall: 'Facility',
        regionSelected: 'Campus',
        campusSelected: 'Facility',
        facilitySelected: 'LocationGrouping',
        locationGroupSelected: 'adcDevice'
    }, this.footprint);
    
    this.filter.$sortOrder = -1;
    this.loadAdminHighRisk({})
    this.refreshData();
  }

  onServiceGrpChanged(event: any){
    this.filter.serviceGroup = event.serviceGroup;
    this.loading = true;
    this.refreshData();
    this.loadAdminHighRisk({});
  }

  openFilterModal() {
      this.filterDialog = !this.filterDialog;
  }

  openRiskScoreChart(row: any){
    row["duration"] = this.filter.duration
    this.selectedAdminData = row;
    this.riskScoreChart.loadRiskScoreChart(row)
    this.showRiskScoreChart = true
  }
  isMultiple(rowData: any){
    try{
      return (rowData.locationGrouping == 'MULTIPLE' || rowData.subParent)
    }
    catch{
      return false
    }
  }
  showMaapInfo(){
    this.maapRiskInfo = true;
  }

  showIndividualDiscrepancy(rowData: any, riskLevel: any) {
    this.messageService.clear(); 
    this.selectedAdminData = rowData;
    this.currentRow = rowData;
    this.riskLevel = riskLevel;
    this.filter.duration = 90
    this.selectedDays = 90
    this.selectedAdminData['bedDev'] = null
    this.selectedAdminData['employeeId'] = rowData['lanId']
    this.selectedAdminData['medGroup'] = null
    this.selectedAdminData['ia'] = true
    this.individualDiscrepancyDialog = !this.individualDiscrepancyDialog;
  }

  onShowModal() {
    this.notesComponent.startPolling()
    this.document.body.classList.add("ovrhidden");
  }

  onHideModal() {
    const adminId = this.currentRow.lanId;
    this.auditService
      .getAuditPagedDataParent(this.page, 10, this.filter, adminId)
      .subscribe(
        (res) => {
          this.currentRow.highRisk = (res as any)["docs"][0]["highRisk"];
          this.currentRow.totalVariance = (res as any)["docs"][0]["totalVariance"];
        });
    this.notesComponent.stopPolling()
    this.document.body.classList.remove("ovrhidden");
  }

  updateLookbackPeriod(lookbackPeriod: any) {
    // Update duration on the active filter directly instead of replacing it with
    // auditRow, which still carries the dialog's original riskLevel and would
    // silently reintroduce that pill after the user clears it.
    this.resolutionComp.filter.duration = lookbackPeriod["value"];
    this.resolutionComp.filter.transactionEndDate = null;
    this.resolutionComp.filter.transactionStartDate = null;
    
    this.resolutionComp.auditRow.duration = lookbackPeriod["value"];
    this.resolutionComp.auditRow.transactionEndDate = null;
    this.resolutionComp.auditRow.transactionStartDate = null;
    this.resolutionComp.filterRecords()
  }

  removeFilter(filter: any){
    this.iaFilter = { ...filter };
    this.resolutionComp.removeVarianceFilters(this.iaFilter, this.selectedDays);
  }
  openFilterModuleAfterMore(filterInputs: any){
    this.resolutionComp.openVarianceFilter({ ...filterInputs });
  }
  sendSelectedRow(riskLevel: any){
    return {
            ia: true,
            employeeId:this.selectedAdminData.employeeId,
            riskLevel: riskLevel,
            locationGrouping:this.selectedAdminData.locationGroupingString,
            duration:90
          }
  }
  getFilterPillsValues(filter: any): void {
    if (!filter) {
      return;
    }

    this.iaFilter = { ...filter };
  }
  openInvActShareModalRisks(){
    const sharableItems = this.resolutionComp.getItemsToBeShared();
    const data = sharableItems.map(item=> item.data);
    (data as any)['deIdentifyData'] = this.filter.deIdentifyData;
    if(data.length < 1){
      alert("no activities selected.")
      return;
     }
    this.showShareModal = true
    this.shareComponent.setSharableData(data, "activities");
   }
   gdfs(s: any){
    // get date from string 
    const d = s.substring(0,10).split('-')
    return d[1] + '-' + '-' + d[0]
  }
   updatedDate(event: any){
    if ( this.individualDiscrepancyDialog && event && event.startDate && event.endDate) {
      this.date = event;
    }
  }

  submitMessageCompleted(event: any) {
    this.commentDialog = false;
    this.followUpDialog = false;
    this.loadAdminHighRisk({})
    if (typeof event !== 'boolean'){
      this.messageService.add(event);
   }
  }

  openFollowUpShare(e: any){
    this.showShareModal = true
    this.shareComponent.setShareableFollowUp(e, "adminfollowup");
  }

  openInvestigativeSummary(){
    this.showInvestigativeSummary = true
    this.InvestigativeSummaryData.selectedRow = this.selectedRow
    this.InvestigativeSummaryData.setData()
  }

  openISShareModal(){
    const shareableItems = this.InvestigativeSummaryData.getItemsToBeShared();
    this.showShareModal = true
    this.shareComponent.setSharableISData(shareableItems, "adminfollowup");
    return
  }

  openISPrintModal(){
    const shareableItems = this.InvestigativeSummaryData.getItemsToBeShared();
    this.showISPrintModal = true
    this.printComponent.setSharableISData(shareableItems, "printInvestigativeSummary");
    return
  }

  closeShareModal(){
    this.showShareModal = false;
  }

  filterHighRiskTableByIds(row: any, col: any){
    if(row['investigator'] == this.auditorSelection.user && col.header == this.auditorSelection.column){
      this.auditorSelection = {}
      this.filter.adminId = []
    }
    else{
    this.auditorSelection = {user:row['investigator'], column:col.header}
    const ids = row[col['field']]
    this.filter.adminId = ids
    }
    this.loadAdminHighRisk({first: 0})
    this.loadAuditorFollowUp({})
  }
  getClass(priority: any) {
    return this.resolutionCodingService.getAuditFollowUptatusBg(priority)
  }
  getFollowUp(followUp: any) {
    if (followUp)
      return followUp
    else 
      return 'Open'
  }

  async showCommentEdit(rowData: any) {
    this.messageService.clear();
    this.selectedRow = rowData;
    this.commentDialog = !this.commentDialog;
    this.documentService.tab = 1
    this.notesComponent.getUserMentions()
    this.notesComponent.getComments(rowData);
  }

  showFollowUpEdit(rowData: any) {
    this.selectedRow = rowData;
    this.followUpDialog = !this.followUpDialog;
    this.followUp.getData(rowData);
    this.documentService.tab = 1
  }

  getCellStyle(followUp: string, rowData: any): Record<string, string> {
    let bgColor = '';
    if(rowData['selectedColumn'] == followUp)
      bgColor = this.getFollowUpBG(followUp,true)
    else
      bgColor = this.getFollowUpBG(followUp,false)

    return {'font-weight': 'bolder', 
          'text-align': 'center', 
          'cursor': 'pointer',
        'background-color':bgColor,
        'color':"rgb(var(--text-on-status-surface))"
      }
  }

  async setInitialFilter(){
    this.filter = {    
      duration: 90, 
      ...this.locationAccessService.buildAuthorizedFilters(
        this.locationAccessService.buildInitialFilters(this.authService.user),
        this.authService.user,
        'locationGroup'
      ),
      serviceGroup: "All"
    }
  }

  onLocationSelectInitialized(initialFilter: any): void {
    this.locationAccessService.applyAuthorizedFilters(this.filter, initialFilter, this.authService.user, 'locationGroup');
    this.filterState = this.dataFilterService.create(this.filter);
    this.filter = cloneFilterState(this.filterState.applied);
    this.refreshData();
  }

  refreshToInitialState(): void {
    if (!this.filterState) this.filterState = this.dataFilterService.create(this.filter);
    this.filterState = this.dataFilterService.refresh(this.filterState);
    this.filter = cloneFilterState(this.filterState.applied);
    this.locationSelectFilter = this.locationAccessService.buildInitialFilters(this.authService.user, {
      footprint: this.footprint,
      changeValue: true
    });
    this.auditorSelection = {};
    this.page = 0;
    this.filterDialog = false;
    this.adminRiskTable?.reset();
    this.loadAdminHighRisk({ first: 0 });
    this.refreshData();
  }

  trackByIndex(index: number): number {
    return index;
  }

// Clean up timeout on component destroy
ngOnDestroy() {
    if (this.locationChangeTimeout) {
        clearTimeout(this.locationChangeTimeout);
    }
  }
}
